module.exports = __webpack_public_path__ + "img/cca-blogo.8d2f6539.svg";